import type { ResourceItemProps } from '@shopify/polaris';

import { Button, InlineStack } from '@shopify/polaris';

interface IProps {
  actions?: ResourceItemProps['shortcutActions'];
}

/**
 * Shortcut actions of a pick-resource row on desktop, revealed when the row is hovered. Mobile has
 * no hover state and renders CampaignPickItemMobileActions instead.
 */
export const CampaignPickItemHoverActions: React.FC<IProps> = ({ actions }) => {
  if (!actions?.length) return null;

  return (
    <div className="hidden md:group-hover/campaign-pick-item:block">
      <InlineStack gap="100" wrap={false}>
        {actions.map((action) => (
          <Button key={String(action.content)} variant="secondary" onClick={action.onAction}>
            {action.content}
          </Button>
        ))}
      </InlineStack>
    </div>
  );
};
